module.exports = __webpack_public_path__ + "38dc2ccb42a1721f7e4b1ee2e4a2ba34.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/menu/slack_dark.svg
// module id = 168
// module chunks = 0